import { render, staticRenderFns } from "./ListRole.vue?vue&type=template&id=3734a7fa&"
import script from "./ListRole.vue?vue&type=script&lang=js&"
export * from "./ListRole.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports